<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">{{ state.title }}</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="page__row">
          <AppCheckbox title="Перевелся"
                       :checked="Boolean(state.isTransferred)"
                       @toggle-check="toggleTransferStatus"
          />
        </div>
        <div class="page__row">
          <AppTextarea title="Комментарий к переводу"
                       :value="state.comment"
                       min-width="420px"
                       input-height="120px"
                       @value-changed="setTransferComment"
          />
        </div>
      </div>
      <div class="transfer-history">
        <div class="title">История переводов</div>
        <div class="transfer-history__list">
          <div class="transfer-history__item" v-for="(item, i) in state.history" :key="i">
            <div class="transfer-history__date">{{ item.date }}</div>
            <div class="transfer-history__text">{{ item.comment }}</div>
            <div class="transfer-history__transfer">
              <div class="transfer-history__transfer-from">{{ item.from }}</div>
              <div class="transfer-history__transfer-icon">
                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 6.1598H12.2545M12.2545 6.1598L7.22372 1M12.2545 6.1598L7.22372 11.3196" stroke="currentColor" stroke-width="1.5"/>
                </svg>
              </div>
              <div class="transfer-history__transfer-to">{{ item.to }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__button-wrap">
        <div class="modal__button">
          <AppButton title="Сохранить" type="main" @click.native="updateTransferInfo"/>
        </div>
        <div class="modal__button">
          <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppCheckbox from '@/components/page/input/AppCheckbox'
import AppTextarea from '@/components/page/input/AppTextarea'

export default {
  name: 'user-transfer-modal',
  components: {
    AppTextarea,
    AppCheckbox,
    AppButton
  },
  props: {
    state: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toggleTransferStatus () {
      this.$emit('toggle-transfer-status')
    },
    setTransferComment (comment) {
      this.$emit('set-transfer-comment', comment)
    },
    updateTransferInfo () {
      this.$emit('update-transfer-info')
    },
    closeModal () {
      this.$emit('close-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal {
  max-width: 500px;

  &__head {
    margin-bottom: 30px;
  }

  &__body {
    width: 100%;
    padding-bottom: 30px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    width: 100%;
    margin-bottom: 30px;
  }

  &__button {
    margin-right: 16px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.transfer-history {
  background: $color__smoke;
  padding: 30px 40px;
  margin-bottom: 30px;

  .title {
    margin-bottom: 20px;
  }

  &__list {
    max-height: 160px;
    overflow: auto;
    padding-right: 12px;

    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: $color__forest-wolf;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color__orange;
    }
  }

  &__item {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid $border_color;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  &__date {
    color: $font_color_second;
    margin-bottom: 10px;
  }

  &__text {
    margin-bottom: 10px;
  }

  &__transfer {
    display: flex;
    flex-flow: row nowrap;
  }

  &__transfer-from {
    color: $color__orange;
    margin-right: 1em;
  }

  &__transfer-to {
    color: $color__green;
    margin-left: 1em;
  }

  &__transfer-icon {
    color: $border_color;
  }
}
</style>
